import { render, staticRenderFns } from "./hw321.vue?vue&type=template&id=05dddbc4&scoped=true&"
import script from "./hw321.vue?vue&type=script&lang=js&"
export * from "./hw321.vue?vue&type=script&lang=js&"
import style0 from "./hw321.vue?vue&type=style&index=0&id=05dddbc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dddbc4",
  null
  
)

export default component.exports